import InsightsBarItem from "./insights-bar-item";

export default InsightsBarItem;
